import { Box, Skeleton, SxProps } from "@mui/material";

type FormSkeletonProps = {
  variant: "input" | "checkbox" | "button";
  sx?: SxProps;
  checkboxSx?: SxProps;
  checkboxLabelSx?: SxProps;
  height?: number;
};
export const FormSkeleton = ({ variant, sx, checkboxSx, checkboxLabelSx, height }: FormSkeletonProps) => {
  if (variant === "checkbox") {
    return (
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", ...sx }}>
        <Skeleton variant="rounded" width={20} height={20} sx={{ m: "9px", ...checkboxSx }} />
        <Skeleton variant="text" sx={{ flex: 1, ...checkboxLabelSx }} />
      </Box>
    );
  }
  if (variant === "button") {
    return <Skeleton variant="rounded" height={height ?? 36.5} />;  
  }
  return <Skeleton variant="rounded" height={height ?? 46.56} />;
};
